<div class="table-responsive">
  <table class="table table-striped table-bordered">
    <thead class="custom-header">
      <tr>
        <th>Nombre</th>
        <th>Descripción</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let download of downloads">
        <td>{{ download.name }}</td>
        <td>{{ download.description }}</td>
        <td>
          <!-- Si el usuario está autenticado, mostrar un solo botón -->
          <div *ngIf="isUserAuthenticated(); else notAuthenticated">
            <button
              class="btn-govco btn-govco hvr-shrink"
              (click)="downloadFile(download.key, download.name)">
              {{ 'observatorio.descargas' | translate }}
            </button>
          </div>
          
          <!-- Si el usuario NO está autenticado, mostrar dos opciones -->
          <ng-template #notAuthenticated>
            <div class="d-flex gap-2 flex-wrap">
              <button
                class="btn-govco btn-govco hvr-shrink btn-box"
                (click)="enviarACorreo(download.key, download.name)">
                Enviar a Correo
              </button>
              <button
                class="btn-govco btn-govco hvr-shrink btn-outline btn-box"
                (click)="descargaEnLinea(download.key, download.name)">
                Descarga en Línea
              </button>
            </div>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div>
  <app-modal-email (correoEmitter)="registrarEmail($event)"> </app-modal-email>
  <app-modal-download
    [isAuth]="isAuth"
    [currentKey]="currentKey"
    [nameFile]="nameFile"
    (correoEmitter)="registrarEmail($event)">
  </app-modal-download>
</div>
